import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../atoms/icon/icon.component';

export interface PageNavItem {
  icon: string;
  label: string;
  targetId: string;
}

@Component({
  selector: 'htx-page-nav',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './page-nav.component.html',
  styleUrl: './page-nav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNavComponent {
  items = input.required<PageNavItem[]>();
  itemClicked = output<PageNavItem>();

  onItemClick(item: PageNavItem): void {
    this.itemClicked.emit(item);
    document.getElementById(item.targetId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
